module.exports = "<div class=\"modal__body\">\n  <div class=\"modal__section\">\n    <iframe ref=\"youtubeIframe\" width=\"100%\" height=\"100%\" src=\"\" frameborder=\"0\" allowfullscreen></iframe>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/modals/video/index.html
// module id = oNjm
// module chunks = 1